export const SideSheetHeader = ({ children }) => {
  return <div className="grid grid-cols-6 gap-4">{children}</div>;
};
